module.exports = __webpack_public_path__ + "static/media/koolicar-logo.28191c24.svg";